// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pagination":"_1ckn0_","arrow":"_3gmSCx","paginationButton":"J0v4oS","active":"_2gUkoG"};